import React from 'react';
import { ApolloProvider } from '@material-bank/apollo-client';
import { CustomerProvider } from '@material-bank/customer';
import { ProjectsCustomerProvider } from '@material-bank/projects-utils';
import { App } from '@mb/App';
import { IntlProvider } from '@mb/lib/i18n/CoordinatedIntlProvider';
import { ThemeProvider } from '@mui/material';
import { theme } from 'theme';
import { FindDistributors } from './components/FindDistributors';
import { IncompleteProfileToast } from './components/IncompleteProfileToast';
import { PreviewFiles } from './components/previewFilesDialog/previewFiles/PreviewFiles';
import { RequestQuote } from './components/RequestQuote';
import {
  GalleryImage,
  ProductAttributeJson,
  ProductConfigurableJson,
} from './types/window';

declare global {
  interface Window {
    productAttributeJson?: ProductAttributeJson;
    productConfigurableJson?: ProductConfigurableJson;
    galleryImages: GalleryImage[];
  }
}

export const DigitalSamplingContainer = () => {
  return (
    <App>
      <ThemeProvider theme={theme}>
        <ApolloProvider>
          <ProjectsCustomerProvider>
            <CustomerProvider>
              <IntlProvider>
                <IncompleteProfileToast />
                <PreviewFiles />
                <FindDistributors />
                <RequestQuote />
              </IntlProvider>
            </CustomerProvider>
          </ProjectsCustomerProvider>
        </ApolloProvider>
      </ThemeProvider>
    </App>
  );
};
